<label class="eventq-boolean-toggle">
  <button
    type="button"
    class="eventq-boolean-toggle__track"
    role="switch"
    [attr.aria-checked]="checked()"
    [attr.aria-label]="label()"
    [attr.aria-disabled]="disabled() ? true : null"
    [disabled]="disabled()"
    [class.eventq-boolean-toggle__track--on]="checked()"
    (click)="requestToggle()"
  >
    <span class="eventq-boolean-toggle__thumb"></span>
  </button>
  @if (showLabel()) {
    <span class="eventq-boolean-toggle__label">{{ label() }}</span>
  }
</label>
